import styled, { css } from 'styled-components';

type ContainerAttributes = {
  $ratio: string | number;
  $translate?: boolean;
  $scroll?: boolean;
};

export const Container = styled.div<ContainerAttributes>(
  ({ $ratio, $translate, $scroll }) => css`
    backface-visibility: hidden;

    overflow-y: hidden;
    position: absolute;
    --ratio: ${$ratio};

    height: 100dvh;
    width: 100vw;

    left: 0px;
    top: 0px;

    ${$translate &&
    css`
      transition: transform 0s linear 0.3s;
      transform: translateY(-38vmax);
    `}

    ${$scroll &&
    css`
      -webkit-overflow-scrolling: none;
      overscroll-behavior: none;
      scroll-behavior: smooth;
    `}
  `
);

export const Overview = styled.video`
  width: calc(100dvh * var(--ratio));
  position: relative;
  max-width: unset;
  height: 100dvh;
  top: 0px;
`;

export const Logo = styled.img`
  margin-inline: auto;
  inset: 62px 0px 0px;
  max-width: 162px;
  position: fixed;
  display: table;
`;

export const Hotspots = styled.div`
  width: calc(100dvh * var(--ratio));
  position: absolute;
  height: 100dvh;
  top: 0px;

  > svg {
    position: absolute;
    height: auto;
    width: 55px;
  }
`;
